/**
 * KM header secondary nav: desktop aria-expanded + Escape; mobile <details> aria + Escape.
 */
(function () {
  const DESKTOP = window.matchMedia('(min-width: 750px)');

  /**
   * @param {Element} item
   * @param {boolean} expanded
   */
  function setDesktopExpanded(item, expanded) {
    const trigger = item.querySelector('.km-hm__subdrop--desktop .km-hm__sublink--parent');
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  /**
   * @param {Element} item
   */
  function bindDesktopItem(item) {
    item.addEventListener('pointerenter', () => {
      if (DESKTOP.matches) setDesktopExpanded(item, true);
    });
    item.addEventListener('pointerleave', () => {
      if (!DESKTOP.matches) return;
      requestAnimationFrame(() => {
        if (!item.contains(document.activeElement)) {
          setDesktopExpanded(item, false);
        }
      });
    });

    item.addEventListener('focusin', () => {
      if (DESKTOP.matches) setDesktopExpanded(item, true);
    });
    item.addEventListener('focusout', () => {
      if (!DESKTOP.matches) return;
      requestAnimationFrame(() => {
        if (!item.contains(document.activeElement)) {
          setDesktopExpanded(item, false);
        }
      });
    });
  }

  /**
   * @param {Element} root
   */
  function bindMobileDetails(root) {
    root.querySelectorAll('.km-hm__subdetails').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      const sync = () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      details.addEventListener('toggle', () => {
        if (!DESKTOP.matches && details.open) {
          root.querySelectorAll('.km-hm__subdetails').forEach((other) => {
            if (other !== details && other instanceof HTMLDetailsElement) {
              other.open = false;
            }
          });
        }
        sync();
      });
      sync();
    });
  }

  /**
   * @param {Element} root
   */
  function bindRoot(root) {
    root.querySelectorAll('.km-hm__subitem--has-dropdown').forEach(bindDesktopItem);
    bindMobileDetails(root);

    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const active = document.activeElement;
      if (!(active instanceof Element) || !root.contains(active)) return;

      const details = active.closest('.km-hm__subdetails');
      if (details instanceof HTMLDetailsElement && details.open) {
        e.preventDefault();
        details.open = false;
        const summary = details.querySelector('summary');
        if (summary instanceof HTMLElement) {
          summary.focus();
          summary.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      if (!DESKTOP.matches) return;

      const item = active.closest('.km-hm__subitem--has-dropdown');
      if (!item || !root.contains(item)) return;
      const trigger = item.querySelector('.km-hm__subdrop--desktop .km-hm__sublink--parent');
      if (!(trigger instanceof HTMLElement)) return;
      e.preventDefault();
      trigger.focus();
      setDesktopExpanded(item, false);
    });
  }

  function resetNavState() {
    document.querySelectorAll('[data-km-header-main] .km-hm__subdetails').forEach((d) => {
      if (d instanceof HTMLDetailsElement) d.open = false;
    });
    document.querySelectorAll('[data-km-header-main] .km-hm__subitem--has-dropdown').forEach((item) => {
      setDesktopExpanded(item, false);
    });
    document.querySelectorAll('[data-km-header-main] .km-hm__subdetails summary').forEach((s) => {
      s.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('[data-km-header-main]').forEach(bindRoot);
  resetNavState();

  function onDesktopChange() {
    resetNavState();
  }

  if (typeof DESKTOP.addEventListener === 'function') {
    DESKTOP.addEventListener('change', onDesktopChange);
  } else if (typeof DESKTOP.addListener === 'function') {
    DESKTOP.addListener(onDesktopChange);
  }
})();
